import React from "react";
import "./index.css"

const Cursor = () => {
    return(
        <span className="inline-block cursor-blink pl-2">
            <span className="bg-green h-[40px] w-[2px] lg:h-[3.125rem] translate-y-[0.5rem] block">

            </span>
            <span className="sr-only">Cursor Icon</span>
        </span>
    )
}

export default Cursor